define('views/modules/setting/personal/blocks/custom-messages/custom-messages-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/setting/personal/blocks/custom-messages/custom-messages-content',
    'services/i18n'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VCustomMessagesContent,
    i18n
) {

    var VCustomMessagesPanel = VBasePanel.extend({
        header: {
            //title: i18n.t("conversation:Edit my custom messages"),
            title: "conversation:Edit my custom messages",
            subtitle: "conversation:Add your own messages",
        },

        tabs: [{
            id: 'showlist',
            title: "conversation:Messages List",
            active: true }],
        content: {
            showlist: VCustomMessagesContent,
        },
        defaultView: 'showlist',

        initialize: function(opt) {
            opt = opt || {};

            var showlist = this.getView('showlist', {
                model: this.model
            });
        },

    });

    return VCustomMessagesPanel;

});

